import React from 'react';
import { withTheme } from 'styled-components';

const ArrowLeftIcon = ({ theme }) => {
  return (
    <svg
      width="19"
      height="39"
      viewBox="0 0 19 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8611 1.02381C16.4002 0.394824 17.3472 0.321982 17.9762 0.861115C18.6052 1.40025 18.678 2.3472 18.1389 2.97619L15.8611 1.02381ZM2 19.5L0.861115 20.4762L0.0243835 19.5L0.861115 18.5238L2 19.5ZM18.1389 36.0238C18.678 36.6528 18.6052 37.5998 17.9762 38.1389C17.3472 38.678 16.4002 38.6052 15.8611 37.9762L18.1389 36.0238ZM18.1389 2.97619L3.13888 20.4762L0.861115 18.5238L15.8611 1.02381L18.1389 2.97619ZM15.8611 37.9762L0.861115 20.4762L3.13888 18.5238L18.1389 36.0238L15.8611 37.9762Z"
        fill={theme.themeColors.arrowButtons.color}
      />
    </svg>
  );
};

export default withTheme(ArrowLeftIcon);
